module.exports = __webpack_public_path__ + "img/img3.a6e88206.jpg";